export default {
  checkInterval: 'checkInterval',
  newCommitCheckInterval: 'New commit check interval',
  schedule: 'Schedule',
  newSchedule: 'New Schedule',
  deleteSchedule: 'Delete Schedule',
  editSchedule: 'Edit Schedule',
  backup: 'Backup Project',
  downloadTheProjectBackupFile: 'Download the project backup file.',
  restoreProject: 'Restore Project...',
  incorrectUsrPwd: 'Incorrect login or password',
  askDeleteUser: 'Do you really want to delete this user?',
  askDeleteTemp: 'Do you really want to delete this template?',
  askDeleteEnv: 'Do you really want to delete this environment?',
  askDeleteInv: 'Do you really want to delete this inventor?',
  askDeleteKey: 'Do you really want to delete this key?',
  askDeleteRepo: 'Do you really want to delete this repository?',
  askDeleteProj: 'Do you really want to delete this project?',
  askDeleteTMem: 'Do you really want to delete this team member?',
  askDeleteSchedule: 'Do you really want to delete this schedule?',
  edit: 'Edit',
  nnew: 'New',
  keyFormSshKey: 'SSH Key',
  keyFormLoginPassword: 'Login with password',
  keyFormNone: 'None',
  incorrectUrl: 'Incorrect URL',
  username: 'Username',
  username_required: 'Username is required',
  dashboard: 'Dashboard',
  history: 'History',
  activity: 'Activity',
  settings: 'Settings',
  signIn: 'Sign In',
  password: 'Password',
  changePassword: 'Change password',
  editUser: 'Edit User',
  newProject: 'New Project',
  close: 'Close',
  newProject2: 'New Project...',
  demoMode: 'DEMO MODE',
  task: 'Task #{expr}',
  youCanRunAnyTasks: 'You can run any tasks',
  youHaveReadonlyAccess: 'You have read-only access',
  taskTemplates: 'Task Templates',
  inventory: 'Inventory',
  environment: 'Variable Groups',
  keyStore: 'Key Store',
  repositories: 'Repositories',
  darkMode: 'Dark Mode',
  team: 'Team',
  users: 'Users',
  editAccount: 'Edit Account',
  signOut: 'Sign Out',
  error: 'Error',
  refreshPage: 'Refresh Page',
  relogin: 'Relogin',
  howToFixSigninIssues: 'How to fix sign-in issues',
  firstlyYouNeedAccessToTheServerWhereSemaphoreRunni: 'First, you need shell access to the ZetaPilot server.',
  executeTheFollowingCommandOnTheServerToSeeExisting: 'Execute the following command on the server to see existing users:',
  semaphoreUserList: 'semaphore user list',
  youCanChangePasswordOfExistingUser: 'You can change password of existing user:',
  semaphoreUserChangebyloginLoginUser123Password: 'semaphore user change-by-login --login user123 --password {makePasswordExample}',
  orCreateNewAdminUser: 'Or create new admin user:',
  close2: 'Close',
  semaphore: 'ZETAPILOT',
  brandClassifier: 'ORCHESTRATOR',
  currentProject: 'Current project',
  projectNavigation: 'Project navigation',
  navGroupOperations: 'Operations',
  navGroupRuntime: 'Runtime',
  navGroupAccess: 'Access',
  navExecutionEnvironments: 'Execution envs',
  search: 'Search…',
  noItems: 'No items',
  noMatches: 'No matches',
  rowsPerPage: 'Rows per page',
  selectedN: '{count} selected',
  deleteN: 'Delete {count}',
  runN: 'Run {count}',
  activateN: 'Activate {count}',
  deactivateN: 'Deactivate {count}',
  bulkDeleteConfirm: 'Delete {count} items? This cannot be undone.',

  // API tokens
  'New Token': 'New Token',
  'API Reference': 'API Reference',
  Cancel: 'Cancel',
  Create: 'Create',
  Active: 'Active',
  Expired: 'Expired',
  Revoked: 'Revoked',
  Expires: 'Expires',
  Never: 'Never',
  Custom: 'Custom',
  'Expiration date': 'Expiration date',
  token: 'Token',
  created: 'Created',
  deleteToken: 'Delete token',
  askDeleteToken: 'Delete this API token? Any client using it will lose access.',
  nDays: '{count} days',
  oneYear: '1 year',
  exampleInventoryHosts: 'Example: inventories/production/hosts',
  skipGalaxyPreflight: 'Skip Galaxy preflight',
  skipGalaxyPreflightHint: 'Disable automatic ansible-galaxy install of roles/collections from requirements.yml before the playbook runs.',

  // Activity stream
  activityAction: 'Action',
  activityObjectType: 'Object type',
  activitySystemActor: 'System',
  activityAction_create: 'Created',
  activityAction_update: 'Updated',
  activityAction_delete: 'Deleted',
  activityAction_run: 'Run',
  activityObjectType_template: 'Template',
  activityObjectType_inventory: 'Inventory',
  activityObjectType_environment: 'Environment',
  activityObjectType_key: 'Access key',
  activityObjectType_repository: 'Repository',
  activityObjectType_schedule: 'Schedule',
  activityObjectType_integration: 'Integration',
  activityObjectType_execution_environment: 'Execution environment',
  activityObjectType_task: 'Task',
  activityObjectType_project: 'Project',
  activityObjectType_user: 'User',
  activityObjectType_view: 'View',
  eeRegistryCredential: 'Registry credentials (optional)',
  eeRegistryCredentialHint: 'Used for `docker login` before pulling the image. Required for private registries (GitLab CR, Harbor, …).',
  keyFormEnvVars: 'Environment variables',
  keyFormEnvVarsLabel: 'KEY=VALUE per line',
  keyFormEnvVarsHint: 'Lines starting with # are ignored. Use this for credential bags like AWS_ACCESS_KEY_ID + AWS_SECRET_ACCESS_KEY, VAULT_TOKEN, etc.',

  // Workflows
  workflows: 'Workflows',
  workflowNodes: 'Nodes',
  newWorkflow: 'New workflow',
  editWorkflow: 'Edit workflow',
  deleteWorkflow: 'Delete workflow',
  askDeleteWorkflow: 'Delete this workflow template? Existing runs will keep their history.',
  noWorkflowsYet: 'No workflows yet',
  workflowDefinition: 'Definition (JSON: nodes + edges)',
  workflowDefinitionInvalid: 'Definition must be a JSON object with arrays `nodes` and `edges`',
  workflowFormDefinitionHelp: 'A workflow is a DAG of templates. Each edge declares when its target node runs: on_success, on_failure or always. Pick a template below to append a node, then edit edges manually.',
  workflowInsertNode: 'Insert node for template…',
  workflowRunStarted: 'Workflow run #{id} started',

  // Execution Environment builds (ansible-builder)
  eeBuilds: 'EE builds',
  newEEBuild: 'New EE build',
  editEEBuild: 'Edit EE build',
  deleteEEBuild: 'Delete EE build',
  askDeleteEEBuild: 'Delete this EE build config? Already-pushed images stay in the registry.',
  noEEBuildsYet: 'No EE build configs yet',
  eeBuildLastImage: 'Last image',
  eeBuildLastBuiltAt: 'Last built at',
  eeBuildImagePrefix: 'Image prefix',
  eeBuildImagePrefixHint: 'Full image name without the tag. Example: registry.example.com/devops/my-ee',
  eeBuildImagePrefixRequired: 'Image prefix is required',
  eeBuildRegistryUrl: 'Registry URL (optional)',
  eeBuildRegistryUrlHint: 'Defaults to the host part of the image prefix. Used for docker login when registry credentials are set.',
  eeBuildDefinition: 'Definition (execution-environment.yml)',
  eeBuildDefinitionHint: 'Verbatim contents of the file consumed by `ansible-builder build`.',
  eeBuildDefinitionRequired: 'Definition is required',
  eeBuildStarted: 'Build started — refresh the list in a moment',
  eeBuildLog: 'Build log',
  eeBuildNoLog: 'No log captured yet',
  bulkRunConfirm: 'Run {count} templates with default parameters?',
  bulkRunSkippedSurvey: '{count} template(s) with required survey variables were skipped.',
  signInTitle: 'Sign in',
  signInSubtitle: 'Use your ZetaPilot account credentials to continue.',
  twoStepVerification: 'Two-step verification',
  accountRecovery: 'Account recovery',
  totpHint: 'Open the two-step verification app on your device to read the current code.',
  emailOtpHint: 'Check your inbox for the verification code we just sent you.',
  recoveryHint: 'Enter a one-time recovery code to regain access to your account.',
  continue: 'Continue',
  or: 'or',
  projectStream: 'Project Stream',
  noFlightsLogged: 'No flights logged',
  noTasksInProjectYet: 'This project hasn\'t run any tasks yet.',
  dashboardSubtitle: 'Project operating state and recent automation runs',
  dashboardUpdated: 'Updated:',
  dashboardRefresh: 'Refresh',
  dashboardOpenTemplates: 'Run task',
  dashboardMetricRunningNote: '{percent}% of recent runs',
  dashboardMetricSuccessNote: '{percent}% of recent runs',
  dashboardMetricFailedNote: '{percent}% of recent runs',
  dashboardMetricQueuedNote: '{percent}% of recent runs',
  dashboardMetricDefaultNote: '{percent}% of recent runs',
  dashboardReadiness: 'Environment readiness',
  dashboardTaskStream: 'Task stream',
  dashboardRecentRuns: 'Recent runs',
  dashboardLastFailure: 'Last failure',
  dashboardLastSuccess: 'Last success',
  dashboardNoMessage: 'No message was provided',
  dashboardNoFailures: 'No failures in recent runs',
  dashboardNoSuccesses: 'No successful runs yet',
  dashboardTopTemplates: 'Top templates',
  dashboardRecentWindow: 'recent',
  dashboardNoTemplateRuns: 'No template runs',
  dashboardSignals: 'Environment signals',
  dashboardSignalHistory: 'History',
  dashboardSignalActive: 'Active',
  dashboardSignalQueue: 'Queue',
  dashboardSignalSuccessRate: 'Success rate',
  dashboardSignalOperators: 'Operators',
  dashboardSignalTemplates: 'Templates',
  dashboardSignalFailures: 'Failures',
  dashboardSignalLatest: 'Latest ID',
  dashboardStatsSubtitle: 'Run volume, status mix, and operator load',
  dashboardActivitySubtitle: 'Project audit trail and operator actions',
  dashboardSettingsSubtitle: 'Project configuration, service actions, and danger zone',
  dashboardAuditTrail: 'Audit trail',
  statsTaskStatus: 'Task status',
  testAlerts: 'Test alerts',
  launchTask: 'Launch task',
  templateId: 'Template ID',
  application: 'Application',
  launchReadiness: 'Launch readiness',
  launchTabSetup: 'Setup',
  launchTabPrompts: 'Prompts',
  launchTabRuntime: 'Runtime',
  launchTabArguments: 'Arguments',
  launchTabReview: 'Review',
  launchRunPlan: 'Run plan',
  launchExecutionTarget: 'Execution target',
  launchOperatorInputs: 'Operator inputs',
  launchRequiredPrompts: 'Required prompts',
  launchOptionalPrompts: 'Optional prompts',
  launchPromptCount: '{count} fields',
  launchTemplateDefault: 'From template',
  launchNotSelected: 'Not selected',
  launchNotRequired: 'Not required',
  launchNoPrompts: 'No prompts',
  launchNoPromptsHint: 'This template starts without extra operator input.',
  launchRuntimeLocked: 'Runtime locked',
  launchRuntimeLockedHint: 'This application has no launch-time runtime controls.',
  launchArgumentsLocked: 'Arguments locked',
  launchArgumentsLockedHint: 'CLI argument override is disabled in the template.',
  statusOk: 'Ok',
  statusFailed: 'Failed',
  statusRunning: 'Running',
  statusQueued: 'Queued',
  statusStarting: 'Starting',
  statusConfirmed: 'Confirmed',
  statusRejected: 'Rejected',
  statusStopping: 'Stopping',
  statusStopped: 'Stopped',
  statusHold: 'Hold',
  pastWeek: 'Past week',
  pastMonth: 'Past month',
  pastYear: 'Past year',
  allUsers: 'All users',
  allRunningTasksStopRequested: 'All running tasks have been requested to stop',
  variableGroupSyncedSuccessfully: 'Variable group synced successfully',
  secretsSyncedSuccessfully: 'Secrets synced successfully',
  inventoryTypeStatic: 'Static',
  inventoryTypeStaticYaml: 'Static YAML',
  inventoryTypeFile: 'File',
  inventoryTypeDynamic: 'Dynamic (Inventory Plugin)',
  tabLog: 'Log',
  tabDetails: 'Details',
  tabSummary: 'Summary',
  taskRun: 'Task Run',
  taskLogsStreaming: 'Logs streaming',
  taskLogsConnected: 'Connected to runner via WebSocket',
  executionTimeline: 'Execution timeline',
  runTelemetry: 'Run telemetry',
  searchLogs: 'Search logs...',
  allLevels: 'All levels',
  wrap: 'Wrap',
  pause: 'Pause',
  resume: 'Resume',
  clear: 'Clear',
  autoScrollOn: 'Auto-scroll on',
  stageQueued: 'Queued',
  stageQueuedHint: 'Task accepted',
  stagePrepare: 'Prepare',
  stagePrepareHint: 'Runner and environment',
  stageRun: 'Run',
  stageFinish: 'Finish',
  stageFinishHint: 'Waiting for completion',
  stageFinishedHint: 'Run completed',
  taskIdentity: 'Task identity',
  templateSource: 'Template & source',
  timing: 'Timing',
  taskPayload: 'Task payload',
  taskParameters: 'Task parameters',
  items: 'items',
  stageAnalysis: 'Stage analysis',
  stage: 'Stage',
  hosts: 'Hosts',
  host: 'Host',
  changed: 'Changed',
  failed: 'Failed',
  ignored: 'Ignored',
  rescued: 'Rescued',
  skipped: 'Skipped',
  unreachable: 'Unreachable',
  anomalies: 'Anomalies',
  noFailures: 'No failures',
  allStagesCompleted: 'All stages completed successfully.',
  allHosts: 'All hosts',
  notOkHosts: 'Not ok hosts',
  taskEvents: 'task events',
  recap: 'Recap',
  end: 'End',
  reject: 'Reject',
  dontHaveAccountOrCantSignIn: 'Don\'t have account or can\'t sign in?',
  password2: 'Password',
  cancel: 'Cancel',
  noViews: 'No views',
  addView: 'Add view',
  editEnvironment: 'Edit Variable Group',
  deleteEnvironment: 'Delete variable group',
  newEnvironment: 'New Group',
  executionEnvironment: 'Execution Environments',
  executionEnvironmentSingular: 'Execution Environment',
  newExecutionEnvironment: 'New Execution Environment',
  editExecutionEnvironment: 'Edit Execution Environment',
  deleteExecutionEnvironment: 'Delete Execution Environment',
  askDeleteEE: 'Do you really want to delete this execution environment?',
  eeImage: 'Container Image',
  eeImagePlaceholder: 'quay.io/ansible/awx-ee:latest',
  eeImageRequired: 'Image is required',
  eePullPolicy: 'Pull Policy',
  eeHint: 'When set on a template, ansible-playbook runs inside this container image. Requires docker on the runner host.',
  environmentName: 'Group Name',
  dockerImage: 'Runner Docker Image (optional)',
  extraVariables: 'Extra variables',
  enterExtraVariablesJson: 'Enter extra variables JSON...',
  environmentVariables: 'Environment variables',
  enterEnvJson: 'Enter env JSON...',
  environmentAndExtraVariablesMustBeValidJsonExample: 'Environment and extra variables must be valid JSON. Example:',
  dashboard2: 'Dashboard',
  ansibleSemaphore: 'ZetaPilot',
  wereSorryButHtmlwebpackpluginoptionstitleDoesntWor: 'We\'re sorry but <%= htmlWebpackPlugin.options.title %> doesn\'t work properly without JavaScript enabled. Please enable it to continue.',
  deleteInventory: 'Delete inventory',
  newInventory: 'New Inventory',
  name: 'Name',
  userCredentials: 'User Credentials',
  userCredentialsOptional: 'User Credentials (Optional)',
  sudoCredentialsOptional: 'Sudo Credentials (Optional)',
  type: 'Type',
  pathToInventoryFile: 'Path to Inventory file',
  enterInventory: 'Enter inventory...',
  staticInventoryExample: 'Static inventory example:',
  staticYamlInventoryExample: 'Static YAML inventory example:',
  dynamicInventoryHelp: 'Paste an Ansible inventory plugin config (e.g. amazon.aws.aws_ec2). The required collection must be installed in the selected Execution Environment. Provider credentials should be passed via Environment secrets (env vars).',
  dynamicInventoryPlaceholder: 'plugin: amazon.aws.aws_ec2\nregions:\n  - eu-west-1\nkeyed_groups:\n  - key: tags.Role\n    prefix: role',
  dynamicInventoryRequiresEE: 'Dynamic inventories rely on Ansible collections that are usually provided by an Execution Environment image. Select one above, or set SEMAPHORE_ALLOW_DYNAMIC_INVENTORY_WITHOUT_EE=1 on the server to opt out.',
  keyName: 'Key Name',
  loginOptional: 'Login (Optional)',
  usernameOptional: 'Username (Optional)',
  privateKey: 'Private Key',
  override: 'Override',
  useThisTypeOfKeyForHttpsRepositoriesAndForPlaybook: 'Use this type of key for HTTPS repositories and for playbooks which use non-SSH connections.',
  deleteKey: 'Delete key',
  newKey: 'New Key',
  create: 'Create',
  newTask: 'New Task',
  cantDeleteThe: 'Can\'t delete the {objectTitle}',
  theCantBeDeletedBecauseItUsedByTheResourcesBelow: 'The {objectTitle} can\'t be deleted because it used by the resources below',
  projectName: 'Project Name',
  allowAlertsForThisProject: 'Allow alerts for this project',
  telegramChatIdOptional: 'Telegram Chat ID (Optional)',
  maxNumberOfParallelTasksOptional: 'Max number of parallel tasks (Optional)',
  deleteRepository: 'Delete repository',
  newRepository: 'New Repository',
  urlOrPath: 'URL or path',
  absPath: 'abs. path',
  branch: 'Branch / Tag',
  accessKey: 'Access Key',
  testConnection: 'Test connection',
  testConnectionOk: 'Connection OK',
  testConnectionSkipped: 'Skipped — nothing to probe for local/file repositories',
  credentialsToAccessToTheGitRepositoryItShouldBe: 'Credentials to access to the Git repository. It should be:',
  ifYouUseGitOrSshUrl: 'if you use Git or SSH URL.',
  ifYouUseHttpsOrFileUrl: 'if you use HTTPS or file URL.',
  none: 'None',
  ssh: 'SSH',
  deleteProject: 'Delete project',
  save: 'Save',
  deleteProject2: 'Delete Project',
  onceYouDeleteAProjectThereIsNoGoingBackPleaseBeCer: 'Once you delete a project, there is no going back. Please be certain.',

  clear_cache: 'Clear cache',
  clear_cache_message: 'Delete all cache files related to this project. This action is irreversible.',

  name2: 'Name *',
  title: 'Title *',
  description: 'Description',
  required: 'Required',
  key: '{expr}',
  surveyVariables: 'Survey Variables',
  addVariable: 'Add variable',
  vaultName: 'Vault ID (optional)',
  vaultNameDefault: 'Only one `default` (empty) name may exist',
  default_value: 'Default value',
  vaultNameUnique: 'Must be unique',
  vaultTypePassword: 'Password',
  vaultTypeScript: 'Client Script',
  vaultScript: 'Script Path',
  vaultScriptRequired: 'Script Path is required',
  vaultScriptClientRequired: 'Script path must end with \'-client\' and extension',
  vaults: 'Vaults',
  vaultAdd: 'Add Vault',
  vaultRequired: 'Vault Password is required',
  columns: 'Columns',
  buildVersion: 'Build Version',
  messageOptional: 'Message (Optional)',
  debug: 'Debug',
  dryRun: 'Dry Run',
  diff: 'Diff',
  advanced: 'Advanced',
  hide: 'Hide',
  pleaseAllowOverridingCliArgumentInTaskTemplateSett: 'To allow overriding CLI argument in Task Template settings',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe: 'CLI Args (JSON array). Example: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  started: 'Started',
  author: 'Author',
  duration: 'Duration',
  stop: 'Stop',
  forceStop: 'Force Stop',
  stopAll: 'Stop All',
  stopAllTasks: 'Stop All Tasks',
  askStopAllTasks: 'Are you sure you want to stop all tasks?',
  forceStopAllTasks: 'Force Stop All Tasks',
  askForceStopAllTasks: 'Are you sure you want to force stop all tasks?',
  raw_log: 'Raw log',

  confirmTask: 'Confirm',
  deleteTeamMember: 'Delete team member',
  team2: 'Team',
  newTeamMember: 'New Team Member',
  user: 'User',
  administrator: 'Administrator',
  definesStartVersionOfYourArtifactEachRunIncrements: 'Defines start version of your artifact. Each run increments the artifact version.',
  forMoreInformationAboutBuildingSeeThe: 'For more information about building, see the',
  taskTemplateReference: 'Task Template reference',
  definesWhatArtifactShouldBeDeployedWhenTheTaskRun: 'Defines what artifact should be deployed when the task run.',
  forMoreInformationAboutDeployingSeeThe: 'For more information about deploying, see the',
  taskTemplateReference2: 'Task Template reference',
  definesAutorunSchedule: 'Defines autorun schedule.',
  forMoreInformationAboutCronSeeThe: 'For more information about cron, see the',
  cronExpressionFormatReference: 'Cron expression format reference',
  startVersion: 'Start Version',
  example000: 'Example: 0.0.0',
  buildTemplate: 'Build Template',
  autorun: 'Autorun',
  playbookFilename: 'Path to playbook file *',
  exampleSiteyml: 'Example: deploy/site.yml',
  inventory2: 'Inventory *',
  repository: 'Repository',
  environment3: 'Variable Groups *',
  environmentsHint: 'Variables from each selected group are merged in order; later groups override earlier ones on conflicts.',
  vaultPassword: 'Vault Password',
  vaultPassword2: 'Vault Password',
  view: 'View',
  cron: 'Cron',
  iWantToRunATaskByTheCronOnlyForForNewCommitsOfSome: 'Auto-run task if new git commit have been found',
  repository2: 'Repository',
  cronChecksNewCommitBeforeRun: 'Cron checks new commit before run',
  readThe: 'Read the',
  toLearnMoreAboutCron: 'to learn more about Cron.',
  suppressSuccessAlerts: 'Suppress success notifications',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe2: 'CLI Args (JSON array). Example: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  allowCliArgsInTask: 'CLI args',
  docs: 'docs',
  editViews: 'Edit Views',
  newTemplate: 'New template',
  taskTemplates2: 'Task Templates',
  all: 'All',
  notLaunched: 'Not launched',
  by: 'by {user_name}',
  editTemplate: 'Edit Template',
  newTemplate2: 'New Template',
  deleteTemplate: 'Delete template',
  playbook: 'Playbook',
  email: 'Email',
  adminUser: 'Admin user',
  sendAlerts: 'Send alerts',
  deleteUser: 'Delete user',
  newUser: 'New User',
  re: 'Re{getActionButtonTitle}',
  teamMember: '{expr} Team Member',
  taskId: 'Task ID',
  status: 'Status',
  start: 'Start',
  actions: 'Actions',
  alert: 'Alert',
  admin: 'Admin',
  role: 'Role',
  external: 'External',
  time: 'Time',
  path: 'Path',
  gitUrl: 'Git URL',
  sshKey: 'SSH Key',
  lastTask: 'Last Task',
  task2: 'Task',
  build: 'Build',
  deploy: 'Deploy',
  run: 'Run',
  add: 'Add',
  password_required: 'Password is required',
  name_required: 'Name is required',
  user_credentials_required: 'User credentials are required',
  type_required: 'Type is required',
  path_required: 'Path to Inventory file is required',
  private_key_required: 'Private key is required',
  project_name_required: 'Project name is required',
  repository_required: 'Repository is required',
  branch_required: 'Branch or tag is required',
  key_required: 'Key is required',
  user_required: 'User is required',
  build_version_required: 'Build version is required',
  title_required: 'Title is required',
  isRequired: 'is required',
  mustBeInteger: 'Must be integer',
  mustBe0OrGreater: 'Must be 0 or greater',
  start_version_required: 'Start version is required',
  playbook_filename_required: 'Playbook filename is required',
  inventory_required: 'Inventory is required',
  environment_required: 'Environment is required',
  email_required: 'Email is required',
  build_template_required: 'Build template is required',
  Task: 'Task',
  Build: 'Build',
  Deploy: 'Deploy',
  Run: 'Run',
  ReBuild: 'Rebuild',
  ReDeploy: 'Redeploy',
  ReRun: 'Rerun',
  CreateDemoProject: 'Create Demo Project',
  LeaveProject: 'Leave Project',
  integration: 'Integration',
  integrations: 'Integrations',
  NewIntegration: 'New Integration',
  EditIntegration: 'Edit Integration',
  DeleteIntegration: 'Delete Integration',
  DeleteIntegrationMsg: 'Are you sure you want to delete this Integration?',
  AddAlias: 'Add Alias',
  LoadAlias: 'Loading aliases...',
  globalAlias: 'Use project alias',
  matcher: 'Matcher',
  matchType: 'Match Type',
  newMatcher: 'New Matcher',
  matchMethod: 'Comparison Method',
  matchBodyDataType: 'Body Data Type',
  extractValue: 'Extract Value',
  newExtractedValue: 'New Extracted Value',
  extractedValueSource: 'Value Source',
  matchKey: 'Key',
  matchValue: 'Value',
  matchOn: 'Match on',
  global: 'Global',
  synchronized: 'synchronized',
  default: 'Default',
  project: 'Project',
  runners: 'Runners',
  newRunner: 'New Runner',
  enabled: 'Enabled',
  scheduleNextRun: 'Next run',
  maxNumberOfParallelTasks: 'Maximum parallel tasks',
  runnerUsage: 'Usage:',
  runnerDockerCommand: 'Docker:',
  runnerToken: 'Token:',
  editRunner: 'Edit Runner',
  deleteRunner: 'Delete Runner',
  newRunnerToken: 'New Runner',
  askDeleteRunner: 'Do you really want to delete runner {runner}?',
  roles_only_enterprise: 'Roles are only available in <b>Enterprise</b> edition.',
  project_runners_only_pro: 'Project-level runners are only available for <b>PRO</b> users.',
  secret_storage_only_pro: 'Secret storages are only available for <b>PRO</b> users.',
  foss_runners_limited: 'The open-source version has limited functionality; full functionality is in the <b>PRO</b> version.',
  learn_more_about_pro: 'Learn more',
  upgrade_to_pro: 'Upgrade',
  contact_admin_to_upgrade: 'Contact your admin to activate PRO features.',
  contact_admin_to_upgrade_enterprise: 'Contact your admin to activate Enterprise features.',

  projectRestoreResult: 'Project restore results',
  projectWithNameRestored: 'Project {projectName} successfully restored.',
  pleaseUpdateAccessKeys: 'Please update them before running tasks.',
  emptyKeysRestored: '{emptyKeys} empty keys added.',
  template: 'Template',
  aliasUrlCopied: 'The alias URL has been copied to the clipboard.',
  yes: 'Yes',
  no: 'No',
  activeTasks: 'Active Tasks',
  taskLocation: 'Location',
  empty: 'Empty',
  noValues: 'No values',
  addArg: 'Add arg',

  status_success: 'Success',
  status_failed: 'Failed',
  status_stopped: 'Stopped',

  api_tokens: 'API Tokens',
  tokenName: 'Token Name',

  // Terraform/OpenTofu/Terragrunt
  auto_approve: 'Auto approve',
  auto_destroy: 'Allow destroy',
  terraform_override_backend: 'Override backend settings',
  terraform_backend_filename: 'Backend filename (default: backend.tf)',
  terraform_invalid_backend_filename: 'Invalid backend filename',

  // Ansible
  tag: 'Tag',
  tag_required: 'Tag is required',
  allowInventoryInTask: 'Inventory',
  allowLimitInTask: 'Limit',
  addLimit: 'Add limit',
  allowDebug: 'Debug',
  addTag: 'Add tag',
  skipTags: 'Skip tags',
  addSkippedTag: 'Add skipped tag',
  tags: 'Tags',
  limit: 'Limit',

  runner_tag: 'Runner tag',
  allow_parallel_tasks: 'Allow parallel tasks',
  task_prompts: 'Prompts',
  ready: 'Ready',
  templateComposerModule: 'Module',
  templateComposerSections: 'Template sections',
  templateComposerStep: 'Step',
  templateComposerIdentity: 'Identity',
  templateComposerSource: 'Source',
  templateComposerRuntime: 'Runtime controls',
  templateComposerLaunchPolicy: 'Launch policy',
  templateComposerReview: 'Review',
  templateComposerFileHint: 'Suggestions appear after selecting a repository; free text is allowed.',
  templateComposerCliArgs: 'CLI args',
  templateComposerCommand: 'Command preview',
  templateComposerReadiness: 'Readiness',
  templateComposerResources: 'Resources',
  templateComposerCapabilities: 'Operator controls',
  templateComposerAutomation: 'Automation',
  templateComposerRiskHints: 'Risk hints',
  templateComposerDefaultBranch: 'default branch',
  templateComposerNoRepository: 'No repository',
  templateComposerParallel: 'parallel',
  templateComposerDefaultRuntime: 'default runtime',
  templateComposerManualOnly: 'manual only',
  templateComposerAnyRunner: 'any runner',
  templateComposerSurveyCount: '{count} variable(s)',
  templateComposerPromptCount: '{enabled}/{total} enabled',
  templateComposerPromptNote: 'Enabled controls become launch-time decisions for operators and schedules.',
  templateComposerPromptArgsDescription: 'Allow custom command line arguments before launch.',
  templateComposerPromptBranchDescription: 'Let operators run another SCM branch or ref.',
  templateComposerPromptInventoryDescription: 'Allow target inventory or workspace changes.',
  templateComposerPromptLimitDescription: 'Allow host limit changes for Ansible runs.',
  templateComposerPromptTagsDescription: 'Allow selecting Ansible tags at launch.',
  templateComposerPromptSkipTagsDescription: 'Allow excluding Ansible tags at launch.',
  templateComposerPromptDebugDescription: 'Expose verbosity controls on task launch.',
  templateComposerPromptAutoApproveDescription: 'Allow launch-time auto approval for IaC runs.',
  templateComposerEntrypointPlaceholder: '<entrypoint>',
  templateComposerCheckName: 'Template has a name',
  templateComposerCheckStartVersion: 'Start version is set',
  templateComposerCheckBuildTemplate: 'Build template is selected',
  templateComposerCheckRepository: 'Repository is selected',
  templateComposerCheckEntrypoint: 'Entrypoint is set',
  templateComposerCheckInventory: 'Inventory/workspace is selected',
  templateComposerCheckEnvironment: 'Environment is selected',
  templateComposerCheckCronRepository: 'Cron repository is selected',
  templateComposerSchedule: 'Schedule',
  templateComposerPreflightRepository: 'Repository checkout',
  templateComposerPreflightRepositoryMissing: 'Select a repository before launch.',
  templateComposerPreflightEntrypoint: 'Entrypoint',
  templateComposerPreflightEntrypointMissing: 'Set a playbook or script path.',
  templateComposerPreflightEntrypointMatched: 'File matched repository suggestions.',
  templateComposerPreflightEntrypointManual: 'Manual path will be used as typed.',
  templateComposerPreflightInventory: 'Targets',
  templateComposerPreflightInventoryMissing: 'Select an inventory or workspace.',
  templateComposerPreflightSchedule: 'Schedule gate',
  templateComposerPreflightScheduleEnabled: 'Cron will check the selected repository.',
  templateComposerPreflightOperatorControls: 'Operator controls',
  templateComposerRiskArgs: 'Operators can override CLI arguments at launch time.',
  templateComposerRiskInventory: 'Operators can switch inventory/workspace when launching.',
  templateComposerRiskParallel: 'Parallel runs can overlap against the same targets.',
  template_advanced: 'Advanced options',
  template_app_options: '{app} options',
  template_app_prompts: '{app} prompts',
  general_settings: 'General',
  danger_zone_settings: 'Danger Zone',
  project_stats: 'Stats',
  allow_override_branch: 'Branch',
  template_common_options: 'Common options',

  template_tasks: 'Tasks',
  template_details: 'Details',
  template_tf_workspaces: 'Workspaces',

  // Role-related translations
  slug: 'Slug',
  slug_required: 'Slug is required',
  slugHint: 'Unique identifier (lowercase, alphanumeric, underscores and hyphens only)',
  invalidSlugFormat: 'Slug must be lowercase, alphanumeric with underscores/hyphens only',
  permissions: 'Permissions',
  canRunProjectTasks: 'Can run project tasks',
  canUpdateProject: 'Can update project',
  canManageProjectResources: 'Can manage project resources',
  canManageProjectUsers: 'Can manage project users',
  newRole: 'New Role',
  editRole: 'Edit Role',
  deleteRole: 'Delete Role',
  askDeleteRole: 'Do you really want to delete this role?',
  Roles: 'Roles',
  role_required: 'Role is required',

  templatePermission: 'Template permissions',

  // System Info Dialog
  systemInfo: 'System Information',
  system: 'System',
  version: 'Version',
  goVersion: 'Go Version',
  gitClient: 'Git Client',
  tmpPath: 'Temp Path',
  homeDirMode: 'Home Dir Mode',
  scheduleTimezone: 'Schedule Timezone',
  ansibleNotFound: 'Ansible not found on this server',
  database: 'Database',
  dbDialect: 'Dialect',
  authentication: 'Authentication',
  passwordLogin: 'Password Login',
  emailOtp: 'Email OTP',
  oidcProviders: 'OpenID Connect',
  notifications: 'Notifications',
  cluster: 'Cluster',
  highAvailability: 'High Availability',
  nodeId: 'Node ID',
  nodeCount: 'Node Count',
  uiInstances: 'UI Instances',
  useRemoteRunner: 'Remote Runners',
  globalRunners: 'Global Runners',
  active2: 'active',
  taskSettings: 'Task Settings',
  maxParallelTasks: 'Max Parallel Tasks',
  maxTaskDuration: 'Max Task Duration',
  maxTasksPerTemplate: 'Max Tasks per Template',
  unlimited: 'Unlimited',
  featureFlags: 'Feature Flags',
  nonAdminCanCreateProject: 'Non-admin Can Create Project',
  viewNames: {
    all: 'All',
    build: 'Build',
    deploy: 'Deploy',
    tools: 'Tools',
    task: 'Task',
    tasks: 'Tasks',
    default: 'Default',
    main: 'Main',
    other: 'Other',
  },
  theme_system: 'System',
  theme_light: 'Light',
  theme_dark: 'Dark',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  helpTooltip: 'Help',
  copy_to_clipboard: 'Copy to clipboard',
};
